import { KeycloakService } from 'keycloak-angular';

import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationInterceptor } from './interceptors/authentication.interceptor';
import { BootstrapAuthService } from './services/bootstrap-auth.service';

const keycloakService = new KeycloakService();

@NgModule({
  imports: [BrowserModule, TranslateModule],
  providers: [
    BootstrapAuthService,
    {
      provide: KeycloakService,
      useValue: keycloakService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
  ],
})
export class AuthModule {}
